<template>
  <div class="sleep-summary">
    <div class="row justify-content-between" style="width: 100%;">
      <div class="col" style="max-width: 32%;" v-if="sleepStatsAvailable">
        <SleepInformation v-if="sleepInfo" :sleep-data="sleepInfo"
         :previous-sleep="previousSleep" :sleepStats="sleepStats" />
      </div>
      <div class="col" v-if="sleepStatsAvailable && this.sleepNaps.length > 0" style="padding-left:0;max-width: 25%">
        <SleepNaps v-if="sleepInfo" :sleep-naps="sleepNaps" :stats-avilable="sleepStatsAvailable" />
      </div>
      <div class="col" v-if="sleepStatsAvailable" style="padding-left:0;"
        :style="this.sleepNaps.length > 0 ? 'width: 43% !important;' : 'width: 68% !important;padding-right:0;'">
        <SleepCircleChart v-if="sleepInfo" 
          :sleep-data="sleepInfo" 
          :sleep-stats="sleepStats" />
      </div>
    </div>
    <div class="row justify-content-between" style="width: 100%;padding-top:1rem;">
      <div class="col" v-if="sleepStatsAvailable" style="width: 30%;max-width: 32%;">
        <SleepStages v-if="sleepInfo" :sleep-data="sleepInfo" />
      </div>
      <div class="col sleep-intensity" v-if="sleepStatsAvailable" style="width: 68%;">
        <SleepHypnoGram :sleep-data="sleepInfo"></SleepHypnoGram>
      </div>
    </div>
  </div>
  <div>
    <button v-if="false" class="done-button">DONE</button>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Utils from "@/helpers/utils";
import Constants from "@/helpers/constants.js";
import SleepNaps from './SleepNaps.vue';
import SleepCircleChart from './SleepCircleChart.vue';
import SleepStages from './SleepStages.vue';
import SleepInformation from './SleepInformation.vue';
import SleepHypnoGram from './SleepHypnoGram.vue';

export default {
  name: 'SleepSummary',
  components: {
    SleepInformation,
    SleepCircleChart,
    SleepNaps,
    SleepStages,
    SleepHypnoGram,
  },
  props: {
    sleepData: {
      type: Object,
      required: true,
    },
    selectedDate: {
      type: String,
      required: false,
    },
    udid: {
      type: String,
      required: false,
    },
    sleepRows: {
      type: Object,
      required: false,
    }
  },
  mounted() {
    if(this.sleepData) {
      this.sleepInfo = this.sleepData;
    }
    this.getUserSleepData();
  },
  data() {
    return {
      sleepInfo: {},
      chartLabels: [],
      chartData: [],
      zoneContributionDetails: null,
      sleepStatsAvailable: false,
      sleepDetails: null,
      sleepNaps: [],
      sleepHistory: [],
      sleepStats : null,
      previousSleep: null,
    }
  },
  watch: {
    sleepData() {
      this.sleepStatsAvailable = false;
      if(this.sleepData) {
        this.sleepInfo = this.sleepData;
        this.getUserSleepData();
      }
    }
  },
  methods: {
    getUserSleepData() {
      this.$store.dispatch("data/userSleepDetails", {
          udid: this.udid,
          sort: Constants.SLEEP_SORT_COLUMN,
          order: Constants.SORT_ASC,
          dt_from: dayjs(this.selectedDate)
            .startOf("day")
            //.subtract(2, "day")
            .subtract(1, "day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.selectedDate)
            .startOf("day")
            //.subtract(1, "day")
            .format(Constants.BUCKET_FORMAT),
        })
        .then((response) => {
          this.sleepDetails = response.data;
          this.sleepNaps = [];
          this.sleepHistory = [];
          this.previousSleep = null;
          if(response.data) {
              this.sleepNaps = [];
              if(response.data.sleepNapDetails.length > 0) {
                  this.sleepNaps = response.data.sleepNapDetails;
              }
              this.sleepHistory = response.data.sleepHistoryDetails;
              if(this.sleepHistory.length > 0) {
                  this.previousSleep = this.sleepHistory.length > 1 ? this.sleepHistory[1] : this.sleepHistory[1];
                  this.calculateSleepStats();
              }
          }
        });
    },
    calculateSleepStats() {
      let bedTimeVariableMins=[], wakeTimeVariableMins=[];
      let maxWakeEvents=0, minWakeEvents=0;
      let maxDeepSleepContinuty = 0,minDeepSleepContinuty = 0;
      let maxBreathingQuality = 0, minBreathingQuality = 0;
      let prevSleepMinutes = 0
      if(this.sleepHistory.length > 1) {
        prevSleepMinutes = this.sleepHistory[1].sleep_minutes - this.sleepHistory[1].awake_minutes;
      }
      
      for(let i=0; i < this.sleepHistory.length;i++) {
          let sleepHistData = this.sleepHistory[i];
          maxWakeEvents = sleepHistData.wake_events > maxWakeEvents ? sleepHistData.wake_events : maxWakeEvents;
          if(minWakeEvents == 0) {
            minWakeEvents = sleepHistData.wake_events;
          } else {
            minWakeEvents = sleepHistData.wake_events < minWakeEvents ? sleepHistData.wake_events : minWakeEvents;
          }
          

          if(this.sleepHistory.length > 1 && i >= 1) {
            let bedTimeDetails = Utils.getTimeDiffInMins(this.sleepHistory[i].status_start_time, this.sleepHistory[i-1].status_start_time);
            let wakeTimeDetails = Utils.getTimeDiffInMins(this.sleepHistory[i].status_end_time, this.sleepHistory[i-1].status_end_time);
            bedTimeVariableMins.push(bedTimeDetails.minutes);
            wakeTimeVariableMins.push(wakeTimeDetails.minutes);

            maxBreathingQuality = sleepHistData.breathing_quality > maxBreathingQuality ? sleepHistData.breathing_quality : maxBreathingQuality;
            if(minBreathingQuality == 0) {
              minBreathingQuality = sleepHistData.breathing_quality;
            } else {
              minBreathingQuality = sleepHistData.breathing_quality < minBreathingQuality ? sleepHistData.breathing_quality : minBreathingQuality;
            }
  
            maxDeepSleepContinuty = sleepHistData.deep_sleep_part_count > maxDeepSleepContinuty ? sleepHistData.deep_sleep_part_count : maxDeepSleepContinuty;
            if(minDeepSleepContinuty == 0) {
              minDeepSleepContinuty = sleepHistData.deep_sleep_part_count;
            } else {
              minDeepSleepContinuty = sleepHistData.deep_sleep_part_count < minDeepSleepContinuty ? sleepHistData.deep_sleep_part_count : minDeepSleepContinuty;
            }
          }
      }

      let bedTimeVariability=0,wakeTimeVariability=0;
      if(bedTimeVariableMins.length > 0) {
        let average = bedTimeVariableMins.reduce((bedTime, b) => bedTime + b, 0) / bedTimeVariableMins.length;
        bedTimeVariability = Math.floor(average);
        average = wakeTimeVariableMins.reduce((bedTime, b) => bedTime + b, 0) / wakeTimeVariableMins.length;
        wakeTimeVariability = Math.floor(average);
      }

      this.sleepStats = {
        bedTimeVariability,
        wakeTimeVariability,
        prevSleepMinutes,
        maxWakeEvents, minWakeEvents,
        maxDeepSleepContinuty, minDeepSleepContinuty,
        maxBreathingQuality, minBreathingQuality,
      }

      this.sleepStatsAvailable = true;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Add your CSS styles here to match the design of the image */
.sleep-intensity {
  background-color: #1C1D1F;
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>